/**
 * Enum representing the execution status of an action.
 */
export enum ExecutionStatus {
    /** The action is currently running. */
    RUNNING = "running",

    /** The action completed successfully. */
    SUCCESS = "success",

    /** The action encountered an error. */
    ERROR = "error",

    /** The action timed out. */
    TIMEOUT = "timeout",

    /** Not Executed */
    NOTEXECUTED = "notexecuted"
}